export const SERVICE_DISCOVERY = 'service-discovery';
export const START_STOP_VM = 'start-stop-vm';
export const AWS_SUPPORT = 'aws-support';
export const GOOGLE_BILLING = 'billing';

export const KEY_SERVICE_DISCOVERY = 1;
export const KEY_START_STOP_VM = 2;
export const KEY_AWS_SUPPORT = 5;
export const KEY_BILLING = 3;

export const AWS_CREDENTIALS_SLUG = {
    SERVICE_DISCOVERY,
    START_STOP_VM,
    AWS_SUPPORT
};

export const CREDENTIALS_SLUG = {
    SERVICE_DISCOVERY,
    START_STOP_VM,
    AWS_SUPPORT,
    GOOGLE_BILLING
};

export const AWS_CREDENTIALS_KEYS = {
    KEY_AWS_SUPPORT,
    KEY_SERVICE_DISCOVERY,
    KEY_START_STOP_VM
};

export const CREDENTIALS_KEYS = {
    KEY_SERVICE_DISCOVERY,
    KEY_START_STOP_VM,
    KEY_AWS_SUPPORT,
    KEY_BILLING
};

export const CREDENTIALS_KEYS_FORMATTER = [
    null,
    SERVICE_DISCOVERY,
    START_STOP_VM,
    null,
    null,
    AWS_SUPPORT
];



// WEBPACK FOOTER //
// ./src/components/security/utils/consts.js